/* Packages */
import React from 'react';
import { createRoot } from 'react-dom/client';

const relatedVehicles = Array.from(document.querySelectorAll('[data-related-vehicles]'));

if (relatedVehicles.length) {
    import(/* webpackChunkName: "RelatedVehicles" */ './components/RelatedVehicles').then(({ default: RelatedVehicles }) => {
        relatedVehicles.forEach((node) => {
            const root = createRoot(node);
            root.render(<RelatedVehicles {...(JSON.parse(node.dataset.relatedVehicles || '{}'))} />);
        });
    });
}